import { render, staticRenderFns } from "./HostLink.vue?vue&type=template&id=2ea8d9a6&"
import script from "./HostLink.vue?vue&type=script&lang=js&"
export * from "./HostLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports